import { Action } from '@ngrx/store';

export const AGREGAR_CARTO = '[CARTO] AgregarCarto';
export const ELIMNAR_CARTO = '[CARTO] EliminarCarto';


export class AgregarCartoAction implements Action {
  readonly type = AGREGAR_CARTO;
  constructor(public IdCarto: string ) {}
}
export class EliminarCartoAction implements Action {
  readonly type = ELIMNAR_CARTO;
  constructor(public IdCarto: string ) {}
}

export type OperCartoActions =
    | AgregarCartoAction
    | EliminarCartoAction;
